module.exports = __webpack_public_path__ + "img/archi3Shadow.9d6322bc.png";